import { encode as base64Encode, decode as base64Decode } from 'js-base64';

export class DTC {
  private k: string;

  gech(d: string): string {
    const t: number = new Date().getTime();
    const p = t.toString() + '|' + d;
    const c: string = this.e(p);

    return c;
  }

  dech(c: string): { d: string; t: number } {
    const d = this.d(c);

    const p = d.match(/^([0-9]+)\|(.+)/);
    if (!p) {
      throw Error('Unable to DECH');
    }

    return {
      d: p[2],
      t: Number.parseFloat(p[1]),
    };
  }

  private e(p: string): string {
    const x = this.x(p);
    return base64Encode(x);
  }

  private d(e: string): string {
    const p = base64Decode(e);
    return this.x(p);
  }

  private x(p: string): string {
    let x = '';
    for (let i = 0; i < p.length; i++) {
      const c = p.charCodeAt(i);
      const k = this.k.charCodeAt(i % this.k.length);
      x += String.fromCharCode(c ^ k);
    }
    return x;
  }

  constructor(k?: string) {
    if (!k) k = 'assignObjectStaticCallsFinalMethods';

    if (k.length != 35) {
      throw new Error('K is invalid');
    }

    this.k = k;
  }
}

export default DTC;
